interface Props {
  unit?: string;
}

export const UsageUnitAdorment = ({ unit }: Props) => {
  return <span style={{ color: 'gray' }}>{unit ? `[${unit}]` : ''}</span>;
};
